export const state = {
  nextStatePlural: "États suivants",
  currentState: "État actuel",
  updateState: "Modifier l'état",
};
